import reducer from './reducers';

export { default as duckSelectors } from './selectors';
export { default as duckOperations } from './operations';
export { default as duckTypes } from './types';

export default reducer;
